// src/App.js
import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import { ReportProvider } from './contexts/ReportContext';
import AuthPage from './components/AuthPage';
import DashboardSidebar from './components/DashboardSidebar';
import BillingSuccess from "./components/BillingSuccess";
import ProtectedRoute from './components/ProtectedRoute';
import './App.css';

// Error Boundary component
class AppErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    console.error('App Error:', error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="container mt-5">
          <div className="row justify-content-center">
            <div className="col-md-6">
              <div className="alert alert-danger">
                <h4>Something went wrong</h4>
                <p>We're sorry, but something unexpected happened.</p>
                <button 
                  className="btn btn-primary"
                  onClick={() => window.location.reload()}
                >
                  Reload Page
                </button>
              </div>
            </div>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}

function App() {
  return (
    <AppErrorBoundary>
      <Router>
        <AuthProvider>
          <ReportProvider>
            <div className="App">
              <Routes>
                {/* Public routes */}
                <Route path="/login" element={<AuthPage />} />
                <Route path="/signup" element={<AuthPage />} />
                <Route path="/auth" element={<AuthPage />} />
                
                {/* Protected routes */}
                <Route path="/" element={<ProtectedRoute><DashboardSidebar /></ProtectedRoute>} />
                <Route path="/dashboard" element={<ProtectedRoute><DashboardSidebar /></ProtectedRoute>} />
                
                {/* Fallback route */}
                <Route path="*" element={<Navigate to="/" replace />} />
                <Route path="/billing/success" element={<BillingSuccess />} />
              </Routes>
            </div>
          </ReportProvider>
        </AuthProvider>
      </Router>
    </AppErrorBoundary>
  );
}

export default App;
